import useIsCobbaiEnabled from '@hooks/vendor/useIsCobbaiEnabled';
import useIsYumaEnabled from '@hooks/vendor/useIsYumaEnabled';
import CobbaiWidget from '@components/CobbaiWidget';
import YumaWidget from '@components/YumaWidget';

export const ServiceWidgets = () => {
  const isCobbaiEnabled = useIsCobbaiEnabled();
  const isYumaEnabled = useIsYumaEnabled();

  return (
    <>
      {isCobbaiEnabled && <CobbaiWidget />}
      {isYumaEnabled && <YumaWidget />}
    </>
  );
};
